export {
  MAX_SLIDE_PAGE_BLOCKS,
  paginateSlideBlocks,
  SLIDE_SETTING_BLOCK_KINDS,
  type SlidePageBlockLayout,
} from "#paginate-slide-blocks";
